export const CrossIcon = ({
  width = '12',
  height = '13',
  color = '#DF1B1B'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.00067 5.58508L11.5926 0.993115C11.9835 0.60223 12.6173 0.60223 13.0082 0.993115C13.399 1.384 13.399 2.01775 13.0082 2.40864L8.41684 6.99995L13.0082 11.5913C13.399 11.9822 13.399 12.6159 13.0082 13.0068C12.6173 13.3977 11.9835 13.3977 11.5926 13.0068L7.00067 8.41482L2.4087 13.0068C2.01781 13.3977 1.38406 13.3977 0.993177 13.0068C0.602291 12.6159 0.602291 11.9822 0.993177 11.5913L5.58449 6.99995L0.993177 2.40864C0.602291 2.01775 0.602291 1.384 0.993177 0.993115C1.38406 0.60223 2.01781 0.60223 2.4087 0.993115L7.00067 5.58508Z"
      fill={color}
    />
  </svg>
);
